import { render, staticRenderFns } from "./myshandle.vue?vue&type=template&id=47b78ec3&scoped=true&"
import script from "./myshandle.vue?vue&type=script&lang=js&"
export * from "./myshandle.vue?vue&type=script&lang=js&"
import style0 from "./myshandle.vue?vue&type=style&index=0&id=47b78ec3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b78ec3",
  null
  
)

export default component.exports